var _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _ellipse7, _ellipse8, _ellipse9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgNornePrikkerDiagramIkon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  "data-name": "Layer 1",
  viewBox: "0 0 200 200"
}, props), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
  cx: 7.5,
  cy: 100.08,
  fill: "#b3b3b3",
  rx: 7.2,
  ry: 7
})), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 99.83,
  cy: 100.08,
  fill: "#2a2a2a",
  rx: 7.2,
  ry: 7
})), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 192.5,
  cy: 99.92,
  fill: "#2a2a2a",
  rx: 7.2,
  ry: 7
})), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 7.17,
  cy: 192.92,
  fill: "#2a2a2a",
  rx: 7.2,
  ry: 7
})), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 99.5,
  cy: 192.92,
  fill: "#2a2a2a",
  rx: 7.2,
  ry: 7
})), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 192.17,
  cy: 192.75,
  fill: "#2a2a2a",
  rx: 7.2,
  ry: 7
})), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 7.17,
  cy: 6.92,
  fill: "#b3b3b3",
  rx: 7.2,
  ry: 7
})), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 99.5,
  cy: 6.92,
  fill: "#999",
  rx: 7.2,
  ry: 7
})), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 192.17,
  cy: 6.75,
  fill: "#2a2a2a",
  rx: 7.2,
  ry: 7
})));
export default SvgNornePrikkerDiagramIkon;